'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.keyframes = exports.getState = exports.StyleRoot = exports.Style = exports.Plugins = undefined;

var _enhancer = require('./enhancer');

var _enhancer2 = _interopRequireDefault(_enhancer);

var _plugins = require('./plugins');

var _plugins2 = _interopRequireDefault(_plugins);

var _style = require('./components/style');

var _style2 = _interopRequireDefault(_style);

var _styleRoot = require('./components/style-root');

var _styleRoot2 = _interopRequireDefault(_styleRoot);

var _getState = require('./get-state');

var _getState2 = _interopRequireDefault(_getState);

var _keyframes = require('./keyframes');

var _keyframes2 = _interopRequireDefault(_keyframes);

var _resolveStyles = require('./resolve-styles');

var _resolveStyles2 = _interopRequireDefault(_resolveStyles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Radium(ComposedComponent) {
  return (0, _enhancer2.default)(ComposedComponent);
}

// Legacy object support.
//
// Normally it would be disfavored to attach these to the `Radium` object
// because it defeats tree-shaking, using instead the ESM exports. But,
// the `Radium` `Enhancer` uses **all** of these, so there's no extra "cost"
// to them being explicitly on the `Radium` object.
Radium.Plugins = _plugins2.default;
Radium.Style = _style2.default;
Radium.StyleRoot = _styleRoot2.default;
Radium.getState = _getState2.default;
Radium.keyframes = _keyframes2.default;

if (process.env.NODE_ENV !== 'production') {
  Radium.TestMode = {
    clearState: _resolveStyles2.default.__clearStateForTests,
    disable: _resolveStyles2.default.__setTestMode.bind(null, false),
    enable: _resolveStyles2.default.__setTestMode.bind(null, true)
  };
}

exports.default = Radium;

// ESM re-exports

exports.Plugins = _plugins2.default;
exports.Style = _style2.default;
exports.StyleRoot = _styleRoot2.default;
exports.getState = _getState2.default;
exports.keyframes = _keyframes2.default;


//////////////////
// WEBPACK FOOTER
// ./~/radium/lib/index.js
// module id = 509
// module chunks = 168707334958949